import { render, staticRenderFns } from "./VehiclePageHeader.vue?vue&type=template&id=c1326758&"
import script from "./VehiclePageHeader.vue?vue&type=script&lang=js&"
export * from "./VehiclePageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports